import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
} from '@mui/material';
import { ReactNode } from 'react';
import ja from 'utils/ja';

interface SettingDBProps {
  open: boolean;
  handleClose: () => void;
  title: string;
  children: ReactNode;
  handleConfirm: () => void;
  isSearch?: boolean;
}

const AppDialog: React.FC<SettingDBProps> = ({
  open,
  handleClose,
  title,
  children,
  handleConfirm,
  isSearch,
}) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          maxWidth: 'unset',
        },
      }}
    >
      <DialogTitle
        sx={{
          textAlign: 'center',
          fontWeight: '700',
          fontSize: { xs: '18px', sm: '22px' },
          padding: '10px 0 15px',
        }}
      >
        {title}
      </DialogTitle>
      <Divider />
      <DialogContent
        sx={{
          padding: 'unset',
        }}
      >
        {children}
      </DialogContent>
      <DialogActions sx={{ padding: '5px 15px 15px' }}>
        <Button onClick={handleClose} sx={{ fontSize: '18px' }}>
          {ja.common.cancel}
        </Button>
        <Button onClick={handleConfirm} sx={{ fontSize: '18px' }}>
          {isSearch ? ja.common.search : ja.common.ok}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default AppDialog;
